import React, { useState, useEffect } from 'react'
import { displayEllipticalString } from '../../helpers'
type Props = {
  about: string
}

const Component = ({ about }: Props): React.ReactElement<React.ComponentProps<any>, any> | null => {
  const [showContent, setShowContent] = useState(false)
  const hideText = !showContent && about.length > 320

  const getText = () => {
    if (hideText) {
      return displayEllipticalString(about, 320)
    } else {
      return about
    }
  }

  useEffect(() => {
    if (about.length > 320) {
      setShowContent(false)
    }
  }, [])

  if (!about) {
    return null
  }

  return (
    <div data-section='user-about-section'>
      <p data-type='user-about-title'> About </p>
      <p
        data-type='user-about-text'
        dangerouslySetInnerHTML={{
          __html: `${(getText() || '').replace(/\n/g, '<br />')}`,
        }}
      />
      {about.length > 320 && (
        <button
          type='button'
          data-type='view-more-button'
          onClick={() => setShowContent(!showContent)}
        >
          {hideText ? 'View more' : 'View less'}
        </button>
      )}
    </div>
  )
}

export default Component